import React, { useEffect, useState } from "react";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Grid,
  IconButton,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import {
  addEmailLog,
  addPriceChange,
  getCCMailFromDB,
  getPurchaseOrderlineItemsByPOID,
  getRevisedPriceDetails,
  shouldMailSendToSupplier,
} from "../services/dataService";
import BasicEditableTable from "./table/BasicEditableTable";
import {
  PO_PRICE_UPDATE_COLUMNS,
  PRICE_REVISED_COLUMNS,
} from "../columns/columns";
import { poUpdateEditableCell } from "./table/cell/poUpdateEditableCell";
import { sendEmail } from "../services/emailService";
import { poPartPriceUpdateEmailTemplate } from "../email-templates/templateGenerator";
import { today } from "../manager/dateManager";
import { toast } from "react-toastify";
import { getUser } from "../services/authService";
import BasicTable from "./table/BasicTable";
import moment from "moment";
import config from "../config/envConfig";
import {
  devCCEmails,
  devToEmails,
  revisedPriceCCMailLive,
  revisedPriceTOMailLive,
} from "../config/emailRecipient";

function POPriceUpdateModal({ handleClose, POID, selectedPrice }) {
  const [poDetailInfo, setPODetailInfo] = useState([]);
  const [loading, setLoading] = useState(false);
  const [oldPriceHistory, setOldPriceHistory] = useState([]);
  const [revisedPriceData, setRevisedPriceData] = useState([]);
  const user = getUser();

  const updatePOData = (rowIndex, columnId, value) => {
    setPODetailInfo((old) =>
      old.map((row, index) => {
        if (index === rowIndex) {
          return {
            ...old[rowIndex],
            [columnId]: value,
          };
        }
        return row;
      })
    );
  };
  useEffect(() => {
    async function getPODetails(poId) {
      try {
        const infoResponse = await getPurchaseOrderlineItemsByPOID(poId);
        setPODetailInfo(infoResponse.data);
        setOldPriceHistory(infoResponse.data);
        const newQtyResponse = await getRevisedPriceDetails(poId);
        setRevisedPriceData(newQtyResponse.data);
      } catch (error) { }
    }
    if (POID) {
      getPODetails(POID);
    }
    return () => {
      setRevisedPriceData([]);
      setOldPriceHistory([]);
      setRevisedPriceData([]);
    };
  }, [POID]);

  const sendPriceChangeRequest = async (poNumber, poid) => {
    setLoading(() => true);
    const response = await getCCMailFromDB({
      params: { SendTo: "Impex" },
    });
    const shouldMailSend = await shouldMailSendToSupplier(poid);
    const bccMail = response.data.BCCMail.split(",");
    const podate = moment(selectedPrice?.PODate).format("MMM YY");
    if (shouldMailSend) {
      await sendEmail({
        receiverAddress:
          config.env === "development" ? devToEmails : revisedPriceTOMailLive,
        cc: config.env === "development" ? devCCEmails : revisedPriceCCMailLive,
        bcc: bccMail,
        receiverName: "Impex Team",
        subject: `${selectedPrice.SupplierShortName}-${selectedPrice.PONumber}/${podate} - Price change Notification PO- ${poNumber}`,
        HTML: poPartPriceUpdateEmailTemplate(poDetailInfo, oldPriceHistory),
        attachments: [],
        templateId: "2",
        alertTime: today(true),
      });
      toast.success("Price change request sent");
      await addEmailLog({
        Mailto: devToEmails,
        MailCc: response.data.CCMail ? response.data.CCMail : "",
        MailSubject: `${selectedPrice.SupplierShortName}-${selectedPrice.PONumber}/${podate} - Price change Notification PO- ${poNumber}`,
        FormName: "Price Change",
        FunctionalityName: "Price update dialog ",
        TriggerDatetime: today(true),
        UId: user.userDetails.UserId,
        HostName: "Test HostName",
        ProjectName: "ImpexPortal",
      });

      let mainData = "";
      for (const item of poDetailInfo) {
        if (poDetailInfo.indexOf(item) === poDetailInfo.length - 1) {
          mainData = mainData + `${item.PartNo}:${item.RatePerUnit}`;
        } else {
          mainData = mainData + `${item.PartNo}:${item.RatePerUnit},`;
        }
      }

      const priceHistroy = [];
      oldPriceHistory.forEach((item, index) => {
        if (item.RatePerUnit !== poDetailInfo[index].RatePerUnit) {
          priceHistroy.push({
            POID: item.POID,
            PONumber: item.PONumber,
            PartNo: item.PartNo,
            OldPrice: item.RatePerUnit,
            NewPrice: poDetailInfo[index].RatePerUnit,
          });
        }
      });
      try {
        const payload = new FormData();
        payload.append("PONumber", poNumber);
        payload.append("PartsPrice", mainData);
        payload.append("CreatedBy", user?.userDetails.UserId);
        if (priceHistroy.length) {
          await addPriceChange(priceHistroy);
        }
      } catch (error) {
        toast.error("Please check details");
      } finally {
        setLoading(() => false);
        handleClose();
      }
    }
    handleClose();
    setLoading(() => false);
  };

  return (
    <Dialog open={Boolean(POID)} onClose={handleClose} sx={{ width: '100%' }}>
      <DialogTitle sx={{
        pr: 8,
        color: "black",


      }}>
        {poDetailInfo[0]
          ? `Update price request for ${poDetailInfo[0].PONumber} `
          : " "}
        <IconButton
          aria-label="close"
          onClick={handleClose}
          sx={{
            position: "absolute",

            right: 8,
            top: 8,
            color: (theme) => theme.palette.grey[500],


          }}
        >
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <DialogContent
        sx={{
          pt: "16px !important",
        }}
      >
        <Grid container spacing={2} sx={{pl:2}}>
          <BasicEditableTable
            columns={PO_PRICE_UPDATE_COLUMNS}
            data={poDetailInfo}
            updateLocalState={updatePOData}
            defaultColumn={poUpdateEditableCell}
          />
        </Grid>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose} sx={{ fontSize: "10px" }}>
          Close
        </Button>
        <Button
          variant="contained"
          onClick={() => {
            sendPriceChangeRequest(
              poDetailInfo[0].PONumber,
              poDetailInfo[0].POID
            );
          }}
          disabled={loading}
          sx={{ fontSize: "10px" }}
        >
          {loading ? "Sending.." : "Send"}
        </Button>
      </DialogActions>
      {revisedPriceData.length !== 0 && (
        <>
          {" "}
          <DialogTitle p={2} sx={{
            color: "black"
          }}>
            {poDetailInfo[0]
              ? `Revised price request for ${poDetailInfo[0].PONumber}`
              : " "}
          </DialogTitle>
          <DialogContent>
            <Grid container spacing={2}  pt={2} pl={2}>
              <BasicTable
                columns={PRICE_REVISED_COLUMNS}
                data={revisedPriceData}
                fontSize="10px"
              />
            </Grid>
          </DialogContent>
        </>
      )}
    </Dialog>
  );
}

export default POPriceUpdateModal;
